$(function () {
  function getPcOrMobileNew() {
    if (window.innerWidth <= 768) {
      return 2
    } else {
      return 1
    }
  }
  function fbImgVIdeoBannerFun() {
    this.currentIndex = 0;
    this._Id = null;
    this.isPc = getPcOrMobileNew();
  }
  fbImgVIdeoBannerFun.prototype = {
    init: function (_sectionName) {
      this._Id = _sectionName;
      if ($(`${this._Id} .js-homebanner-slid`).length > 1) {
        this.swiperFun();
      }
    },
    event: function () {},
    playVideo: function (videodom) {
      if (videodom.length > 0) {
        videodom.each(function (index, elemet) {
          let _isrc = $(elemet).attr("src");
          if (_isrc && elemet.paused) {
            let playPromise = elemet.play();
            if (playPromise !== undefined) {
              playPromise
                .then(() => {
                  elemet.play();
                })
                .catch(() => {});
            }
            // elemet.play()
          }
        });
      }
    },
    pausedVideo: function (videodom) {
      if (videodom.length > 0) {
        videodom.each(function (index, elemet) {
          let _isrc = $(elemet).attr("src");
          if (_isrc && !elemet.paused) {
            elemet.pause();
          }
        });
      }
    },
    swiperFun: function () {
      let _this = this;
      let swiperName = `${_this._Id}>.fbHomeImgVideoBanner`;
      let setSpeed = $(`${_this._Id} .fbHomeImgVideoBanner`).attr("data-speed") || 5;
      setSpeed = parseInt(setSpeed)  * 1000;
      const swiperSingleGoods = new Swiper(swiperName, {
        autoplay: false,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        on: {
          slideChange: function () {
            let realIndex = parseInt(this.realIndex) + 1;
            let _current = $(
              `${_this._Id} .js-homebanner-slid[data-number=${realIndex}]`,
            );
            let type = _current.attr("data-type");
            if (type === "video_banner") {
              let _video1 = _current.find("video");
              _this.playVideo(_video1);
            } else {
              let video_all = $(
                `${_this._Id} .js-homebanner-slid[data-type=video_banner]`,
              );
              let _video2 = video_all.find("video");
              _this.pausedVideo(_video2);
            }
          },
        },
        navigation: {
          nextEl: `${_this._Id} .banner-swiper-button-next`,
          prevEl: `${_this._Id} .banner-swiper-button-prev`,
        },
        pagination: {
          el: `${_this._Id} .fbhomebaner-swiper-pagination`,
          clickable: true,
        },
      });
    },
  };
  let fbhomebannerType = $('.fb-newhome-baner[data-type="swiper"]');
  if (fbhomebannerType.length > 0) {
    $.each(fbhomebannerType, function (i, item) {
      let id = $(item).attr("id");
      new fbImgVIdeoBannerFun().init(`#${id}`);
    });
  }
});
